import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/base/JsonLd';
import HeroSection from './components/HeroSection';
import HotGossipSection from './components/HotGossipSection';
import LatestArticlesSection from './components/LatestArticlesSection';
import AppDownloadSection from './components/AppDownloadSection';
import StatsSection from './components/StatsSection';
import TestimonialsSection from './components/TestimonialsSection';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '爆料吃瓜网 - 91爆料吃瓜官网入口 · App下载 · 网红黑料大瓜每日更新',
  description: '爆料吃瓜网提供91爆料吃瓜官网入口与App下载，实时追踪网红黑料、明星八卦和全网热议大瓜，每日同步更新独家爆料与吃瓜资源。',
  url: 'http://wjf5l.cn/',
  isPartOf: {
    '@type': 'WebSite',
    name: '爆料吃瓜网',
    url: 'http://wjf5l.cn/',
  },
};

const faqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '爆料吃瓜网是什么？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '爆料吃瓜网是国内领先的娱乐八卦资讯聚合平台，提供91爆料吃瓜官网入口与App下载，实时追踪网红黑料、明星八卦和全网热议大瓜，每日同步更新独家爆料与吃瓜资源。',
      },
    },
    {
      '@type': 'Question',
      name: '如何下载爆料吃瓜App？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '您可以在Apple App Store或各大Android应用商店搜索「爆料吃瓜」下载官方App，支持iOS和Android双平台。下载后开启推送通知即可第一时间获取最新爆料。',
      },
    },
    {
      '@type': 'Question',
      name: '爆料吃瓜网的内容更新频率如何？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '爆料吃瓜网全天候24小时实时追踪娱乐圈最新动态，每日更新数十条独家爆料内容，覆盖明星八卦、网红黑料、综艺爆料、影视吃瓜等多个领域。',
      },
    },
    {
      '@type': 'Question',
      name: '如何向爆料吃瓜网投稿？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '您可以将独家爆料线索发送至投稿邮箱 hello@wjf5l.cn，经核实采用的爆料将获得丰厚报酬，爆料吃瓜网严格保护爆料人隐私信息。',
      },
    },
    {
      '@type': 'Question',
      name: '爆料吃瓜网的内容可信度如何？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '爆料吃瓜网实行严格的审核机制，每条爆料需经至少两位独立爆料人交叉验证。平台累计发布超过10,000条独家爆料帖，爆料准确率保持在98%以上。',
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <JsonLd data={homeJsonLd} />
      <JsonLd data={faqJsonLd} />
      <Navbar />
      <main>
        <HeroSection />
        <HotGossipSection />
        <LatestArticlesSection />
        <AppDownloadSection />
        <StatsSection />
        <TestimonialsSection />
      </main>
      <Footer />
    </>
  );
}